import { shallowEqual, useSelector } from 'react-redux';

export default function useReduxSelector<T = object>(
  selector: (a: (state: any) => any) => T,
  equalityFn: (left: T, right: T) => boolean = shallowEqual,
) {
  return useSelector(selector, equalityFn);
}
